import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, Shield, FileText, CreditCard } from 'lucide-react';
import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function RentalManagementPage() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/settings`);
        setSettings(response.data);
      } catch (error) {
        console.error('Error loading settings:', error);
      }
    };
    fetchSettings();
  }, []);

  return (
    <div data-testid="rental-management-page" className="min-h-screen pt-20">
      <section className="py-24 md:py-32 px-6 md:px-12 lg:px-24">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          <h1 className="text-5xl md:text-7xl font-serif tracking-tight leading-none">
            {settings?.rental_hero_title || "Gestion Locative"}
          </h1>
          <p className="text-base md:text-lg leading-relaxed text-muted-foreground">
            {settings?.rental_hero_subtitle || "Confiez-nous la gestion de votre patrimoine immobilier et profitez d'une tranquillité d'esprit totale"}
          </p>
          <Link to="/login">
            <Button data-testid="rental-cta" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-full px-8 py-6 text-sm uppercase tracking-widest font-semibold transition-all duration-300 btn-primary">
              Accéder à mon espace
              <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </Link>
        </div>
      </section>

      <section data-testid="rental-features" className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-secondary">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white border border-border p-8 space-y-4">
              <Shield className="w-12 h-12 text-primary" />
              <h3 className="text-2xl font-serif tracking-tight">{settings?.rental_feature1_title || "Sécurité"}</h3>
              <p className="text-muted-foreground leading-relaxed">
                {settings?.rental_feature1_description || "Accès sécurisé à toutes vos informations et documents importants"}
              </p>
            </div>

            <div className="bg-white border border-border p-8 space-y-4">
              <FileText className="w-12 h-12 text-primary" />
              <h3 className="text-2xl font-serif tracking-tight">{settings?.rental_feature2_title || "Documents"}</h3>
              <p className="text-muted-foreground leading-relaxed">
                {settings?.rental_feature2_description || "Consultez vos baux, factures et documents administratifs en ligne"}
              </p>
            </div>

            <div className="bg-white border border-border p-8 space-y-4">
              <CreditCard className="w-12 h-12 text-primary" />
              <h3 className="text-2xl font-serif tracking-tight">{settings?.rental_feature3_title || "Paiements"}</h3>
              <p className="text-muted-foreground leading-relaxed">
                {settings?.rental_feature3_description || "Suivez l'historique de vos paiements et loyers en temps réel"}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32 px-6 md:px-12 lg:px-24">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-serif tracking-tight mb-8">Comment ça marche?</h2>
          <div className="space-y-8">
            <div className="flex gap-6">
              <div className="flex-shrink-0 w-12 h-12 bg-primary text-primary-foreground rounded-full flex items-center justify-center font-bold">1</div>
              <div>
                <h3 className="text-xl font-serif mb-2">Créez votre compte</h3>
                <p className="text-muted-foreground">Inscrivez-vous en quelques clics pour accéder à votre espace personnel</p>
              </div>
            </div>

            <div className="flex gap-6">
              <div className="flex-shrink-0 w-12 h-12 bg-primary text-primary-foreground rounded-full flex items-center justify-center font-bold">2</div>
              <div>
                <h3 className="text-xl font-serif mb-2">Consultez vos biens</h3>
                <p className="text-muted-foreground">Accédez à toutes les informations de vos biens en gestion</p>
              </div>
            </div>

            <div className="flex gap-6">
              <div className="flex-shrink-0 w-12 h-12 bg-primary text-primary-foreground rounded-full flex items-center justify-center font-bold">3</div>
              <div>
                <h3 className="text-xl font-serif mb-2">Gérez facilement</h3>
                <p className="text-muted-foreground">Téléchargez vos documents, suivez vos paiements et communiquez avec notre équipe</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default RentalManagementPage;